import { slugify, normalizeSlug } from './casoSlug'

/** Slug de ruta: `titulo-del-articulo` */
export function getPrensaSlug(prensa) {
  return slugify(prensa?.title)
}

export function findPrensaBySlug(prensa, slug) {
  const normalized = normalizeSlug(slug)
  if (!normalized) return null
  return (prensa ?? []).find((item) => getPrensaSlug(item) === normalized) ?? null
}
